import React from 'react';
import { 
  Globe, 
  Smartphone, 
  MessageCircle, 
  UtensilsCrossed, 
  Search, 
  Headphones 
} from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Globe,
  Smartphone,
  MessageCircle,
  UtensilsCrossed,
  Search,
  Headphones
};

const Services = () => {
  return (
    <section id="services" className="services-section">
      <div className="section-container">
        <div className="section-header-center">
          <h2 className="section-title-large">Nuestros Servicios</h2>
          <p className="section-subtitle">
            Soluciones digitales completas para que tu negocio destaque en internet
          </p>
        </div>

        <div className="services-grid">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div key={service.id} className="service-card">
                <div className="service-icon-wrapper">
                  <IconComponent className="service-icon" size={40} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <div className="service-card-glow"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
